/**
 * useScrollLock — 모달/오버레이 열릴 때 body 스크롤 잠금
 *
 * iOS Safari에서 position:fixed + overflow:hidden만으로는 충분하지 않기 때문에
 * 현재 scrollY를 저장하고 body를 fixed 처리, 닫힐 때 원위치 복원.
 */
import { useEffect } from 'react';

export function useScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;

    const scrollY = window.scrollY;
    const body = document.body;
    const originalStyle = {
      position: body.style.position,
      top: body.style.top,
      width: body.style.width,
      overflow: body.style.overflow,
    };

    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    return () => {
      body.style.position = originalStyle.position;
      body.style.top = originalStyle.top;
      body.style.width = originalStyle.width;
      body.style.overflow = originalStyle.overflow;
      window.scrollTo(0, scrollY);
    };
  }, [locked]);
}
